import { ReactNode } from 'react';

import styles from './FundingSteps.module.css';
import { LoadingAnimation } from '../../ui/loadingAnimation/LoadingAnimation';

const LoadingOverlay = ({ children }: { children?: ReactNode }) => {
    return (
        <div
            className={styles.loadingOverlay}
            data-testid="funding-requirement-loading-overlay"
        >
            <div className={styles.loadingOverlayInner}>
                <LoadingAnimation />
                {children}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default LoadingOverlay;
